import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
import { DataResourceProvider } from './DataResourceContext';
import { OrderProvider } from './OrderContext';
import { PaginationProvider } from './PaginationContext';
import { SearchProvider } from './SearchContext';
import { SelectedItemsProvider } from './SelectedItemsContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function TableProvider(props) {
  const {
    withSearch,
    children,
    params,
    model,
    baseApi,
    postFix = [],
    withCheckbox,
    paginationOptions = {},
    sortOptions = {},
    queryOptions,
    isLoading: customIsLoading
  } = props;
  const allPostFix = `/${postFix.join('/')}`;
  const modelResource = baseApi || getModelBasePath(model);
  const resource = `${modelResource}${postFix.length > 0 ? allPostFix : ''}`;
  return /*#__PURE__*/_jsx(PaginationProvider, _extends({}, paginationOptions, {
    children: /*#__PURE__*/_jsx(OrderProvider, _extends({}, sortOptions, {
      children: /*#__PURE__*/_jsx(SearchProvider, {
        children: /*#__PURE__*/_jsx(DataResourceProvider, {
          withSearch: withSearch,
          resource: resource,
          params: params,
          queryOptions: queryOptions,
          customIsLoading: customIsLoading,
          children: /*#__PURE__*/_jsx(SelectedItemsProvider, {
            withCheckbox: withCheckbox,
            children: children
          })
        })
      })
    }))
  }));
}
export default TableProvider;